import React,{Fragment} from 'react'
import PropTypes from 'prop-types'

const ProfileAbout = ({
    profile:{
        bio,
        skills,
        user:{name}
    }
}) => {
    return (
        <div class="profile-about bg-light">
        {
            bio && (
                <Fragment>
                    <h2 class="text-primary">{name.trim().split(' ')[0]}s bio</h2>
                    <p>{bio}</p>
                </Fragment>
            )
        }
              
              <div class="line p-3">
                <h2 class="text-primary">Skill set</h2>
                <div class="skills">
                    {skills.map((skill, index) => (
                        <div key={index} className="p-1">
                        <i className="fas fa-check"/> {skill}
                        </div>
                    ))}
                </div>
              </div>
            </div>
    )
}

ProfileAbout.propTypes = {
    profile:PropTypes.object.isRequired,
}

export default ProfileAbout
